<template>
    <div class="shuttle-list">
      <h1>Shuttle List</h1>
      <button class="btn btn-primary" @click="openCreateForm">Create Shuttle</button>
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Shuttle Name</th>
            <th>Staff ID</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="shuttle in shuttles" :key="shuttle.id">
            <td>{{ shuttle.id }}</td>
            <td v-if="!shuttle.isEditing">{{ shuttle.shuttlename }}</td>
            <td v-else><input type="text" v-model="shuttle.shuttlename"></td>
  
            <td v-if="!shuttle.isEditing">{{ shuttle.staffid }}</td>
            <td v-else><input type="number" v-model="shuttle.staffid"></td>
  
            <td v-if="!shuttle.isEditing">{{ shuttle.description }}</td>
            <td v-else><input type="text" v-model="shuttle.description"></td>
  
            <td class="action-buttons">
              <button v-if="!shuttle.isEditing" class="btn btn-warning" @click="editShuttle(shuttle)">Edit</button>
              <button v-if="!shuttle.isEditing" class="btn btn-danger" @click="deleteShuttle(shuttle.id)">Delete</button>
              <button v-if="shuttle.isEditing" class="btn btn-success" @click="saveShuttle(shuttle)">Save</button>
              <button v-if="shuttle.isEditing" class="btn btn-secondary" @click="cancelEdit(shuttle)">Cancel</button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- Create Shuttle Form -->
      <div v-if="showCreateForm" class="create-shuttle-form">
        <h5>Create New Shuttle</h5>
        <form @submit.prevent="createShuttle">
          <div class="mb-3">
            <label for="shuttlename" class="form-label">Shuttle Name</label>
            <input type="text" class="form-control" id="shuttlename" v-model="newShuttle.shuttlename" required>
          </div>
          <!-- Maybe in the future they will want to link a shuttle to person, this is where we can start -->
          <!-- <div class="mb-3">
            <label for="staffid" class="form-label">Staff ID</label>
            <input type="number" class="form-control" id="staffid" v-model="newShuttle.staffid">
          </div> -->
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <input type="text" class="form-control" id="description" v-model="newShuttle.description">
          </div>
          <button type="submit" class="btn btn-primary">Create</button>
          <button type="button" class="btn btn-secondary" @click="closeCreateForm">Cancel</button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import ShuttleDataService from "@/services/ShuttleDataService";
  
  export default {
    data() {
      return {
        shuttles: [],
        newShuttle: {
          shuttlename: '',
          staffid: null,
          description: ''
        },
        showCreateForm: false
      };
    },
    methods: {
      fetchShuttles() {
        ShuttleDataService.getAllShuttles()
          .then(response => {
            this.shuttles = response.data.map(shuttle => ({
              ...shuttle,
              isEditing: false,
              originalData: { ...shuttle } // Store original data for cancel functionality
            }));
          })
          .catch(error => {
            console.error("Error fetching shuttles:", error);
          });
      },
      createShuttle() {
        ShuttleDataService.createShuttle(this.newShuttle)
          .then(() => {
            this.fetchShuttles(); // Refresh the list
            this.closeCreateForm(); // Hide the form after creation
          })
          .catch(error => {
            console.error("Error creating shuttle:", error);
          });
      },
      editShuttle(shuttle) {
        shuttle.isEditing = true;
      },
      saveShuttle(shuttle) {
        ShuttleDataService.editShuttle(shuttle.id, shuttle)
          .then(() => {
            shuttle.isEditing = false;
            shuttle.originalData = { ...shuttle }; // Update original data
            this.fetchShuttles(); // Refresh the list
          })
          .catch(error => {
            console.error("Error updating shuttle:", error);
          });
      },
      cancelEdit(shuttle) {
        Object.assign(shuttle, shuttle.originalData); // Restore original data
        shuttle.isEditing = false;
      },
      deleteShuttle(shuttleId) {
        if (confirm("Are you sure you want to delete this shuttle? This action cannot be undone.")) {
          ShuttleDataService.deleteShuttle(shuttleId)
            .then(() => {
              this.fetchShuttles();
            })
            .catch(error => {
              console.error("Error deleting shuttle:", error);
              alert("An error occurred while trying to delete the shuttle.");
            });
        }
      },
      openCreateForm() {
        // Reset the form
        this.newShuttle = {
          shuttlename: '',
          staffid: null,
          description: ''
        };
        this.showCreateForm = true;
      },
      closeCreateForm() {
        this.showCreateForm = false;
      }
    },
    created() {
      this.fetchShuttles();
    }
  };
  </script>
  
  <style scoped>
  /* Add styles here */
  .create-shuttle-form {
    padding: 20px;
    margin-top: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  </style>
  